// ==============================|| OVERRIDES - DRAWER ||============================== //

export default function Drawer() {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          // scrolling belongs to the SimpleBar inside; the paper itself must never scroll
          overflow: 'hidden'
        }
      }
    }
  };
}
